import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

import {
  getCallLogsCallRecord,
  getCallLogsTicketInfo,
  getDetailsCallLogs,
} from '@services/requests/helpdeskAI';
import { currentUserDataSelector } from '@store/selectors';

import Loading from '@common/Loading/Loading';
import transformCallData from '@ui/pages/AIVoiceAssist/helpers';
import DetailItem from './components/DetailItem';

import useStyles from './styles';

const AIDetailCallHistory = ({ match }) => {
  const tenantCountryCode = useSelector(currentUserDataSelector)
    ?.tenantCountryCode;

  const [loading, setLoading] = useState(false);
  const [detailsData, setDetailsData] = useState({});

  const classes = useStyles();
  const onMount = useCallback(() => {
    setLoading(true);
    getDetailsCallLogs(match.params.id)
      .then(async res => {
        let ticket = {};
        let callRecord = '';
        let ticketLink = '';
        if (res.ticketId) {
          ticket = await getCallLogsTicketInfo(res.id);
          if (res.callRecord) {
            callRecord = await getCallLogsCallRecord(res.id)
              .then(res1 => res1.blob())
              .then(blob => {
                return URL.createObjectURL(blob);
              })
              .catch(console.error);
          }

          if (res.ticketLink) {
            ticketLink = (
              <a href={res.ticketLink} target="_blank" rel="noreferrer">
                {res.ticketId}
              </a>
            );
          }
        }
        setDetailsData(
          transformCallData(
            { ...res, ticket, callRecord, ticketLink },
            tenantCountryCode,
          ),
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, [match.params.id, tenantCountryCode]);

  useEffect(() => {
    onMount();
  }, [onMount]);

  if (loading) return <Loading />;

  return (
    <div className={classes.container}>
      {Object.keys(detailsData).map(section => (
        <div key={section} className={classes.cardWrapper}>
          <Typography className={classes.sectionTitle}>{section}</Typography>
          {detailsData[section].map(detailsItem => (
            <DetailItem key={detailsItem.label} item={detailsItem} />
          ))}
        </div>
      ))}
    </div>
  );
};

AIDetailCallHistory.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }),
};

export default AIDetailCallHistory;
